var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhotos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3333 12H4.66665C3.92998 12 3.33331 11.4033 3.33331 10.6667V3.33333C3.33331 2.59667 3.92998 2 4.66665 2H13.3333C14.07 2 14.6666 2.59667 14.6666 3.33333V10.6667C14.6666 11.4033 14.07 12 13.3333 12Z",
    stroke: "#73737B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.664 14.0003H2.66665C1.92998 14.0003 1.33331 13.4036 1.33331 12.6669V5.59961",
    stroke: "#73737B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.56379 4.54816C7.99779 4.98216 7.99779 5.68582 7.56379 6.11982C7.12978 6.55382 6.42613 6.55382 5.99213 6.11982C5.55813 5.68582 5.55813 4.98216 5.99213 4.54816C6.42613 4.11416 7.12979 4.11416 7.56379 4.54816",
    stroke: "#73737B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 9.22163L12.4093 7.41563C12.122 7.18563 11.702 7.2323 11.472 7.51963L9.75729 9.66296C9.52729 9.9503 9.10796 9.99696 8.81996 9.76696L7.95396 9.0743C7.67063 8.84763 7.25796 8.88896 7.02529 9.1683L4.66663 11.9996",
    stroke: "#73737B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotos);
export default __webpack_public_path__ + "static/media/photos.989be3ed.svg";
export { ForwardRef as ReactComponent };